import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { Awesome } from "@components/Helpers";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function StatisticsGeneral({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:general", { game_id: gameId }));
    const commonInfo = useRouteLoaderData("commonInfo");

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <Table bordered size="sm" style={{ width: "500px" }}>
                <tbody>
                    <tr>
                        <th style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {t("Создано заказов")}
                            <Awesome
                                type="question-circle"
                                color="#2d7dd0"
                                tooltip_hide={500}
                                tooltip={
                                    <>
                                        {t(
                                            "Количество заказов, инициированных пользователями (заказ создан, но не обязательно завершён)."
                                        )}
                                    </>
                                }
                            />
                        </th>
                        <td>{apiData.orders_created}</td>
                    </tr>
                    <tr>
                        <th style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {t("Оплачено заказов")}
                            <Awesome
                                type="question-circle"
                                color="#2d7dd0"
                                tooltip_hide={500}
                                tooltip={<>{t("Количество заказов, по которым прошла успешная оплата.")}</>}
                            />
                        </th>
                        <td>{apiData.orders_paid}</td>
                    </tr>
                    <tr>
                        <th style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {t("Вишлисты за все время")}
                            <Awesome
                                type="question-circle"
                                color="#2d7dd0"
                                tooltip_hide={500}
                                tooltip={
                                    <>
                                        {t(
                                            "Общее количество пользователей, добавивших игру в список желаемого (wishlist) за всё время."
                                        )}
                                    </>
                                }
                            />
                        </th>
                        <td>{apiData.wishlists}</td>
                    </tr>
                    <tr>
                        <th style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {t("Оформлено возвратов")}
                            <Awesome
                                type="question-circle"
                                color="#2d7dd0"
                                tooltip_hide={500}
                                tooltip={
                                    <>
                                        {t(
                                            "Количество заказов, по которым пользователи оформили возврат. Включает завершённые и находящиеся в процессе возвраты."
                                        )}
                                    </>
                                }
                            />
                        </th>
                        <td>{apiData.refunds}</td>
                    </tr>
                    {commonInfo?.account?.is_super && apiData.is_steam_gift && (
                        <tr>
                            <th>{t("Продано копий (GiftBot)")}</th>
                            <td>{apiData.copies_sold_gift}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </CommonCard>
    );
}
